








































import { ClientAccount } from '@/shared/clients/client-account';
import { AdditionalDocumentType } from '@/shared/types/additional-document-type';
import { Validator } from 'vee-validate';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

@Component
export default class ClientAdditionalDetails extends Vue {
    @typesModule.Getter('additionalDocumentTypes') private additionalDocumentTypes!: Array<AdditionalDocumentType>;

    @Inject('$validator') public $validator!: Validator;
    @Prop({ required: true }) public client!: ClientAccount;

    private selectedAdditionalDocumentTypes: Array<string> = [...this.client.additionalDocuments.map((document) => document.additionalDocumentTypeId)];
    private isOtherTextRequired: boolean = this.client.additionalDocuments.some((d) => d.otherText != null);
    private otherText: string | null = this.client.additionalDocuments.some((d) => d.otherText != null) ? this.client.additionalDocuments.find((d) => d.otherText != null)!.otherText! : null;


    @Watch('selectedAdditionalDocumentTypes', { deep: true })
    private onAdditionalDocumentTypeChanged(): void {
        this.isOtherTextRequired = this.additionalDocumentTypes.filter((type) => this.selectedAdditionalDocumentTypes.some((t) => t === type.id)).some((type) => type.isOtherTextRequired);
        this.onChange();
    }

    @Watch('otherText')
    private onOtherTextChanged(value: string): void {
        this.onChange();
    }

    private get filteredAdditionalDocumentTypes(): Array<AdditionalDocumentType> {
        if (this.additionalDocumentTypes == null) {
            return [];
        }

        return this.additionalDocumentTypes.filter((type) => !type.isArchived || this.client.additionalDocuments.some((t) => t.additionalDocumentTypeId === type.id));
    }

    private onChange(): void {
        const result: Array<{ id: string, otherText: string | null }> = [];

        for (const id of this.selectedAdditionalDocumentTypes) {
            const type = this.additionalDocumentTypes.find((t) => t.id === id);
            result.push({ id, otherText: type!.isOtherTextRequired ? this.otherText : null });
        }

        this.$emit('change', [...result]);
    }
}
